
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/livescore",
      function () {
        return require("private-next-pages/livescore.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/livescore"])
      });
    }
  